// src/redux/dashboardSlice.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { makeApiCall } from "../../makeAPICall";
import { DASHBOARD_CONTROLLER } from "../../actionTypes";

export const getDashboards = createAsyncThunk(
  "productCategory/getDashboards",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "post",
        `/${DASHBOARD_CONTROLLER}`,
        obj,
        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dashboards: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getDashboards.pending, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(getDashboards.fulfilled, (state, action) => {
        const data = action.payload.data;
        state.dashboards = data;
        state.loading = false;
        state.error = null;
      })
      .addCase(getDashboards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = dashboardSlice.actions;
export default dashboardSlice.reducer;
